import ChatCard from "components/DesignSystem/ChatCard/ChatCard";
import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";
import { AvatarGroup } from "components/DesignSystem/AvatarGroup/AvatarGroup";
import { ChatCardButton } from "./ChatCardButton";
import { MentionIcon } from "components/icons/MentionIcon";
import { VendorEmailRequestModal } from "components/Vendors/VendorEmailRequestModal";
import { pluralize } from "utils/pluralize";
import { useModal } from "hooks/useModal";
import { Button } from "components/DesignSystem/Button/Button";
import { Check } from "components/icons/Check";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";

type MerchantEmailRequestCardProps = {
  customData: CustomData;
  messageId: string;
  size: "regular" | "block";
};

export const MerchantEmailRequestCard = ({
  customData,
  messageId,
  size,
}: MerchantEmailRequestCardProps) => {
  const emailRequestModal = useModal();
  const {
    merchant_details: merchantDetails,
    merchant_count: merchantCount = 0,
    submitted_count: submittedCount = 0,
    season = "",
    task_id: taskId = "",
  } = customData?.metadata || {};

  const areAllEmailsSubmitted = merchantCount === submittedCount;

  return (
    <ChatCard.Root size={size}>
      <ChatCard.Header>
        <div className="t-flex t-gap-1.5 t-items-center">
          {areAllEmailsSubmitted ? (
            <Check className="t-text-dark_green" />
          ) : (
            <MentionIcon className="t-text-neutral" />
          )}
          {areAllEmailsSubmitted ? (
            <span>Email Address Submitted</span>
          ) : (
            <span>Email Address Requested</span>
          )}
        </div>
      </ChatCard.Header>
      <ChatCard.Body>
        <div className="t-flex t-flex-col t-gap-y-4">
          <div className="t-flex t-gap-2 t-items-center">
            {merchantDetails && merchantDetails.length > 0 && (
              <div className="t-relative">
                <AvatarGroup
                  max={2}
                  variant="fill"
                  className="!t-bg-[#58517029] t-text-text-30"
                >
                  {merchantDetails.map((merchant) => (
                    <Avatar
                      key={merchant.uuid}
                      src={merchant.logo || ""}
                      alt={merchant.name}
                      className="t-ring-2 t-ring-white"
                    />
                  ))}
                </AvatarGroup>
              </div>
            )}
            <span className="t-text-subtext-sm t-text-text-60">
              {pluralize(merchantCount, "vendor", "vendors")}
            </span>
          </div>
          {!areAllEmailsSubmitted && (
            <span className="t-text-body-sm t-text-orange-80 t-bg-yellow-10 t-w-fit t-px-1.5 t-py-0.5 t-rounded-2xl">
              {submittedCount} of {merchantCount} completed
            </span>
          )}
          {areAllEmailsSubmitted ? (
            <Button size="small" onClick={emailRequestModal.open}>
              View emails
            </Button>
          ) : (
            <ChatCardButton
              urlText="Add email"
              handleCardAction={emailRequestModal.open}
            />
          )}
        </div>
      </ChatCard.Body>
      {emailRequestModal.isOpen && (
        <VendorEmailRequestModal
          show={emailRequestModal.isOpen}
          closeModal={emailRequestModal.close}
          merchantIds={merchantDetails?.map(({ uuid }) => uuid).join(",") || ""}
          taskId={taskId}
          season={season}
          messageId={messageId}
          submittedCount={submittedCount}
          merchantCount={merchantCount}
        />
      )}
    </ChatCard.Root>
  );
};
